var $ = jQuery;
var $window = $(window);
var $html = $('html');
var $body = $('body');
var $main = $('main');
var $header = $('header');
var $footer = $('footer');
var globalSmoother = null;

var navHandler = {
  
  scrollTimer: null,
  featuredProjectsDuration: 11500, //in ms

  init: function() {
    var self = this;

    this.$logoColorFlips = $('.logo-color-flip');
    this.$toastContainer = $('.toast .toast-text');
    this.$navMenu = $('.nav-menu');
    this.$navCarousel = $('.nav-menu .featured-projects-carousel');

    // extra padding for non-hero pages
    // mustPadTop is set on top.php
    if (mustPadTop) {
      $main.addClass('top-padded');
    }

    // change header color on scroll
    $window.on("scroll", function() {
      clearTimeout(self.scrollTimer);
      self.scrollTimer = setTimeout(function() {
        self.switchHeaderClass();
      }, 15);
      self.showScrollAnim();
    });

    this.switchHeaderClass();

    // headroom
    var headroom  = new Headroom(document.querySelector("header"));
    headroom.init();  

    // back to top
    $('a[href="#top"]').on("click", function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 250);  
    });

    // nav menu
    /*
    $('.menu-toggle').on("click", function() {
      self.toggleNavMenu();
    });
    */

    // nav carousel
    this.$navCarousel.css('--featured-projects-transform-duration', this.featuredProjectsDuration+'ms');
    this.$navCarousel.flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      wrapAround: true,
      draggable: false,
      pageDots: false,
      prevNextButtons: false,
      selectedAttraction: 0.02,
      // friction: 0.75,
      autoPlay: this.featuredProjectsDuration,
      pauseAutoPlayOnHover: false,  
    });
    this.$navCarousel.on('select.flickity', function() {
      $(this).find('.carousel-cell').removeClass('is-active');
    });
    this.$navCarousel.on('settle.flickity', function(event, index) {
      $(this).find('.carousel-cell').eq(index).addClass('is-active');
    });

    // stagger scroll reveal animation
    $('[data-scroll-reveal]').each(function() {
      var scrollAnimDelay = $(this).css('--scroll-anim-stagger-delay');
      $(this).find('[data-scroll-reveal-item]').each(function(index, element) {
        var $current = $(this);
        // if ($current.is('[data-scroll-reveal-item="slide-up"]')) {
        //   $current.css('--child-width', ($current.children().eq(0).outerWidth() * -1)+'px');
        //   $current.css('--child-height', ($current.children().eq(0).outerHeight())+'px');
        // }
        $(this).children().css('transition-delay', (parseInt(scrollAnimDelay) * index)+'ms');
      })
    });

    self.showScrollAnim();

  },

  switchHeaderClass: function() {
    var windowTop = $window.scrollTop();
    this.$logoColorFlips.each(function() {
      var currentTop = $(this).offset().top;
      var currentBottom = currentTop + $(this).outerHeight();
      if (windowTop >= currentTop && windowTop <= currentBottom) {
        $body.addClass('logo-color-flipped');
        return false;
      } else {
        $body.removeClass('logo-color-flipped');        
      }
    })
  },

  toastTimer: null,
  displayToast(message) {
    var self = this;
    this.$toastContainer.html(message).parent().removeClass('hide');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function() {
      self.$toastContainer.parent().addClass('hide');
    }, 2000);
  },

  toggleNavMenu: function() {
    this.$navMenu.toggleClass('is-active');
    if (this.$navMenu.is('.is-active')) {
      globalSmoother.paused(true);
      $html.addClass('disable-scroll');
      this.adjustNavCarousel(true);
      this.$navCarousel.flickity('select', 0, true, true);
      this.$navCarousel.find('.carousel-cell').eq(0).addClass('is-active');
      this.$navCarousel.flickity('playPlayer');
    } else {
      globalSmoother.paused(false);
      $html.removeClass('disable-scroll');
      this.$navCarousel.flickity('pausePlayer');
    }
  },

  adjustNavCarousel: function(resize) {
    if (Foundation.MediaQuery.is('medium')) {
      var totalSiblingsHeight = 0;
      this.$navMenu.find('.nav-center').siblings().each(function() {
        totalSiblingsHeight += $(this).outerHeight();
      });
      this.$navMenu.find('.nav-center').css('--nav-center-height', (this.$navMenu.outerHeight() - totalSiblingsHeight - $('.nav-menu-contacts').outerHeight())+'px');  
    }
    if (resize) {
      this.$navCarousel.flickity('resize');
    }
  },

  showScrollAnim: function() {
    var windowTop = $window.scrollTop();
    var windowBottom = windowTop + $window.height();
    $('[data-scroll-reveal]').not('.scroll-revealed').each(function() {
      var $current = $(this);
      if ($current.offset().top < windowTop + 0.9 * $window.height()) {
        $current.addClass('scroll-revealed');
      }
    });
  }
};

var filterHandler = {
  onItemAdded: null,
  init: function() {
    var self = this;
    $('[data-filter-pager]').on('click', 'a', function(e) {
      e.preventDefault();
      var $target = $(this);
      var page = $target.data('page');
      if (page == 'first') {
        $target.next().trigger('click');
      } else if (page == 'last') {
        $target.prev().trigger('click');
      } else {
        $(this).siblings().not('[data-page="first"],[data-page="last"]').removeClass('is-active dot-on-edge');
        $(this).addClass('is-active dot-on-edge');
        var $displayDiv = $target.parents('[data-filter-pager]').siblings('[data-filter-display]');
        var delayCounter = 0;
        $displayDiv.children().addClass('hide');
        $displayDiv.removeClass('paged');
        $displayDiv.children().each(function() {
          if ($(this).data('page') == page) {
            $(this).removeClass('hide').css({
              'transition-delay': (delayCounter)+'ms',
            });
            delayCounter += 200;
            if (typeof self.onItemAdded == 'function') {
              self.onItemAdded($(this), $displayDiv);
            }
          }
        });
        setTimeout(function() {
          $displayDiv.addClass('paged');          
        }, 50);
      }
    });
    var $filterCriteria = $('[data-filter]');
    $filterCriteria.each(function() {
      $(this).find('a').on('click', function() {
        var $currentFilterItem = $(this);
        var filterData = $currentFilterItem.parents('[data-filter]').data('filter');
        var filterCriteria = $currentFilterItem.parents('[data-filter]').data('filter-criteria');
        var filterValue = $currentFilterItem.data('filter-value');
        // visuals
        $currentFilterItem.parent().siblings().removeClass('is-active');
        $currentFilterItem.parent().addClass('is-active');
        // clone entries from data div to display div
        var $dataDiv = $('[data-filter-data="'+filterData+'"]');
        var $displayDiv = $dataDiv.siblings('[data-filter-display]');
        $displayDiv.empty();
        $dataDiv.find('[data-filter-'+filterCriteria+']').each(function() {
          var $currentItem = $(this);
          var shouldAdd = false;
          if (filterValue == 'all') shouldAdd = true;
          var itemFilterValues = $currentItem.data('filter-'+filterCriteria).split(',');
          $.each(itemFilterValues, function() {
            if (this == filterValue) {
              shouldAdd = true;
              return false;
            }
          });
          if (shouldAdd) {
            $currentItem.clone().appendTo($displayDiv);
          }
        });
        // paging
        var $pagingDiv = $dataDiv.siblings('[data-filter-pager]').find('> *');
        var itemsPerPage = parseInt($displayDiv.data('items-per-page'));
        var itemsCount = $displayDiv.children().length;
        var counter = 0;
        $displayDiv.children().each(function(idx, child) {
          if (idx % itemsPerPage == 0) counter++;
          $(this).data('page', counter);
        });
        $pagingDiv.empty();
        if (itemsCount > itemsPerPage) {
          $dataDiv.siblings('[data-filter-pager]').removeClass('hide');
        } else {
          $dataDiv.siblings('[data-filter-pager]').addClass('hide');
        }
        $('<a href="#" class="filter-page" data-page="first"><span class="fa-light fa-chevron-left"></span></span').appendTo($pagingDiv);
        for (var i=1; i<=(itemsCount/itemsPerPage)+1; i++) {
          $('<a href="#" class="filter-page" data-page="'+i+'"><span></span>'+(i)+'</a>').appendTo($pagingDiv);
        }
        $('<a href="#" class="filter-page" data-page="last"><span class="fa-light fa-chevron-right"></span></span').appendTo($pagingDiv);
        $pagingDiv.find('a[data-page="1"]').trigger('click');
      });
      $(this).find('a').eq(0).trigger('click');
    });
  }
};

$(document).foundation();

$(document).ready(function($) {

  document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  $('<span></span>').prependTo($('.dot-on-edge'));

  navHandler.init();
  filterHandler.init();

  // content format: bleed content images to screen edges
  // content should be one from WYSIWYG
  // bleed-content-images is its immediate parent
  $('.bleed-content-images').each(function() {
    $(this).find('img').parent().addClass('counter-grid-padding medium-cancel-counter-grid-padding');
  });

  $('#brands-tab').on('change.zf.tabs', function() {
    var $targetTabContent = null;
    $(this).find('.tabs-title').each(function(idx, element) {
      if ($(this).is('.is-active')) {
        $targetTabContent = $('.tabs-panel'+$(this).find('a').attr('href'));
        return false;
      }
    });
    if ($targetTabContent) {
      $targetTabContent.find('.scroll-revealed').removeClass('scroll-revealed');
      setTimeout(function() {
        navHandler.showScrollAnim();
      }, 500);
    }
  });

  // debugger
  $window.on('resize', function() {
    $('body').css('--header-height', $header.outerHeight()+'px');
    $('body').css('--window-height', $window.outerHeight()+'px');
    navHandler.adjustNavCarousel(true);
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
